export function generateGradientChartBackground(
  label: string,
  viewRef: any,
  data: any[]
) {
  let dataSets:any[] = [];

  // Create gradient fill
  var gradient = (viewRef as any)
    .getContext("2d")
    .createLinearGradient(0, 0, 0, 600);

  gradient.addColorStop(0, "#E8B844");
  gradient.addColorStop(0.3, "#FDD73F");
  gradient.addColorStop(0.9, "rgba(0, 0, 0, 0)");

  if (data.length > 0) {
    dataSets.push({
      label: label,
      data: data,
      borderColor: "#E8B844",
      fill: true,
      backgroundColor: gradient,
      pointRadius: 0,
      pointHoverRadius: 5,
      borderWidth: 2,
      tension: 0.5
    });
  }
  return dataSets;
}

export function generatePositiveAndNegativeChartBackground(
  vuetify: any,
  label: string,
  viewRef: any,
  data: any[]
) {
  let down = (point: number, value: string) => (point < 0 ? value : undefined);
  let idle = (point: number, value: string) => (point == 0 ? value : undefined);
  let up = (point: number, value: string) => (point > 0 ? value : undefined);
  let dataSets:any[] = [];

  // Create gradient fill
  var positiveGradient = (viewRef as any)
    .getContext("2d")
    .createLinearGradient(0, 0, 0, 600);
  positiveGradient.addColorStop(
    1,
    vuetify.theme.currentTheme.botAgainstMarketBorderColor
  );
  positiveGradient.addColorStop(
    0.6,
    vuetify.theme.currentTheme.botAgainstMarketFillColor
  );

  var negativeGradient = (viewRef as any)
    .getContext("2d")
    .createLinearGradient(0, 0, 0, 600);
  negativeGradient.addColorStop(
    0.2,
    vuetify.theme.currentTheme.negativeChartColor
  );
  negativeGradient.addColorStop(1, "#d7494a");

  if (data.length > 0) {
    dataSets.push({
      label: label,
      data: data,
      pointRadius: 0,
      pointHoverRadius: 5,
      borderWidth: 2,
      tension: 0.5,
      fill: {
        above: positiveGradient,
        below: negativeGradient,
        target: { value: 0 },
      },
      pointBackgroundColor: (context: any) =>
        idle(context.parsed.y, "gray") ||
        down(context.parsed.y, "#d7494a") ||
        up(
          context.parsed.y,
          vuetify.theme.currentTheme.botAgainstMarketBorderColor
        ),
      segment: {
        borderColor: (context: any) =>
          idle(context.p0.parsed.y, "gray") ||
          down(context.p0.parsed.y, "#d7494a") ||
          up(
            context.p0.parsed.y,
            vuetify.theme.currentTheme.botAgainstMarketBorderColor
          ),
      },
    });
  }
  return dataSets;
}

export function getTimeScales(vuetify: any, showHourly: boolean = false): any {
  // Show x labels as hours
  if (showHourly) {
    return {
      type: "time",
      time: {
        tooltipFormat: "dd/MM/yyyy HH:mm:ss",
        unit: "hour",
        displayFormats: {
          hour: "HH:mm",
        },
        color: vuetify.theme.currentTheme.chartLabel,
      },
      ticks: {
        color: vuetify.theme.currentTheme.chartLabel,
        font: { family: "Aeroport" },
      },
      grid: {
        color: vuetify.theme.currentTheme.chartGridColor,
        borderColor: vuetify.theme.currentTheme.chartGridColor
      }
    };
  }

  // Show x labels as days
  return {
    type: "time",
    time: {
      tooltipFormat: "dd/MM/yyyy HH:mm:ss",
      unit: "day",
      displayFormats: {
        day: "d MMM",
      },
      color: vuetify.theme.currentTheme.chartLabel,
    },
    ticks: {
      color: vuetify.theme.currentTheme.chartLabel,
      font: { family: "Aeroport" },
    },
    grid: {
      color: vuetify.theme.currentTheme.chartGridColor,
      borderColor: vuetify.theme.currentTheme.chartGridColor
    }
  };
}
